export default "__VITE_ASSET__73ccb421__"